document.addEventListener("DOMContentLoaded", function () {
  const fields = [
    "chainPrice",
    "chainFeet",
    "braceletLength",
    "charmPrice",
    "charmCount",
    "welding",
    "profit"
  ];

  function money(value) {
    return Number(value).toFixed(2);
  }

  function getValue(id) {
    return parseFloat(document.getElementById(id).value) || 0;
  }

  function updateSliderTrack(input) {
    const min = Number(input.min);
    const max = Number(input.max);
    const value = Number(input.value);
    const percent = ((value - min) / (max - min)) * 100;

    input.style.background =
      `linear-gradient(90deg, #c59b54 ${percent}%, #e7e2d8 ${percent}%)`;
  }

  function animatePrice(newPrice) {
    const priceEl = document.getElementById("recommendedPrice");
    const start = parseFloat(priceEl.dataset.current || 0);
    const duration = 350;
    const startTime = performance.now();

    function update(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const current = start + ((newPrice - start) * progress);

      priceEl.textContent = money(current);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        priceEl.dataset.current = newPrice;
      }
    }

    requestAnimationFrame(update);

    priceEl.classList.remove("pj-price-pop");
    void priceEl.offsetWidth;
    priceEl.classList.add("pj-price-pop");
  }

  function calculatePrice() {
    const chainPrice = getValue("chainPrice");
    const chainFeet = getValue("chainFeet");
    const braceletLength = getValue("braceletLength");
    const charmPrice = getValue("charmPrice");
    const charmCount = getValue("charmCount");
    const welding = getValue("welding");
    const profit = getValue("profit");

    const totalChainInches = chainFeet * 12;
    const braceletCount = Math.floor(totalChainInches / braceletLength);

    const totalChainCost = chainPrice * chainFeet;
    const chainCostPerBracelet = braceletCount > 0 ? totalChainCost / braceletCount : 0;
    const charmCostPerBracelet = charmPrice * charmCount;

    const costPerBracelet =
      chainCostPerBracelet +
      charmCostPerBracelet +
      welding;

    const recommendedPrice = costPerBracelet + profit;

    const profitMargin =
      recommendedPrice > 0
        ? (profit / recommendedPrice) * 100
        : 0;

    const markup =
      costPerBracelet > 0
        ? (profit / costPerBracelet) * 100
        : 0;

    document.getElementById("chainPriceValue").innerText = money(chainPrice);
    document.getElementById("chainFeetValue").innerText = chainFeet;
    document.getElementById("braceletLengthValue").innerText = braceletLength;
    document.getElementById("charmPriceValue").innerText = money(charmPrice);
    document.getElementById("charmCountValue").innerText = charmCount;
    document.getElementById("weldingValue").innerText = money(welding);
    document.getElementById("profitValue").innerText = money(profit);

    document.getElementById("braceletCount").innerText = braceletCount;
    document.getElementById("costPerBracelet").innerText = money(costPerBracelet);
    document.getElementById("totalChainCost").innerText = money(totalChainCost);

    document.getElementById("profitEarned").innerText = money(profit);
    document.getElementById("profitMargin").innerText = profitMargin.toFixed(1);
    document.getElementById("markup").innerText = markup.toFixed(1);

    document.getElementById("marginFill").style.width =
      Math.min(profitMargin, 100) + "%";

    document.getElementById("summaryPrice").innerText = money(recommendedPrice);
    document.getElementById("summaryCost").innerText = money(costPerBracelet);
    document.getElementById("summaryProfit").innerText = money(profit);
    document.getElementById("summaryMargin").innerText = profitMargin.toFixed(1);
    document.getElementById("summaryMarkup").innerText = markup.toFixed(1);

    animatePrice(recommendedPrice);

    fields.forEach(function (id) {
      updateSliderTrack(document.getElementById(id));
    });
  }

  fields.forEach(function (id) {
    const input = document.getElementById(id);

    if (input) {
      input.addEventListener("input", calculatePrice);
      updateSliderTrack(input);
    }
  });

  calculatePrice();
});